import { memo, useCallback, useMemo } from 'react';
import { push } from 'redux-first-history';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import { useDispatch, useSelector } from '@client/hooks/redux.hooks';
import { startRedeemShowTicket } from '@client/slices/entities/tickets.reducer';
import { getTicketPath } from '@sda/utils/url';
import { Checkbox, Form } from '@client/components/forms';
import { getCurrentShowProfiles } from '@client/selectors/entities/shows';
import { Button } from '@client/components/common/Button';
import { InlineBackdrop } from '@client/components/common/Backdrop';
import { joinBy } from '@sda/utils/array';
import type { RedeemableTicket } from '@sda/interfaces/ticket';

export const Redeem = memo<RedeemableTicket>(({
  id: ticketId,
  showId,
}) => {
  const dispatch = useDispatch();
  const profiles = useSelector(getCurrentShowProfiles);

  const shareLabel = useMemo(() => `Share my email with ${joinBy(profiles, 'name', ' and ')}`, [profiles]);

  const handleSubmit = useCallback((values) => {
    dispatch(startRedeemShowTicket({ ticketId, values }));
  }, [dispatch, ticketId]);

  const handleSuccess = useCallback(() => {
    dispatch(push(getTicketPath(showId)));
  }, [dispatch, showId]);

  return (
    <InlineBackdrop color="success">
      <Formik
        initialValues={{ shareContact: false }}
        onSubmit={handleSubmit}
      >
        {({ setSubmitting }) => (
          <Form>
            <Typography variant="subtitle2">
              Claim ticket(s)
            </Typography>

            <Checkbox
              name="shareContact"
              labelNoWrap={false}
            >
              {shareLabel}
            </Checkbox>

            <Button
              type="submit"
              scope={`redeem-ticket-${ticketId}`}
              variant="contained"
              color="success"
              size="large"
              fullWidth
              onSuccess={handleSuccess}
              onError={() => setSubmitting(false)}
            >
              Claim Ticket(s)
            </Button>
          </Form>
        )}
      </Formik>
    </InlineBackdrop>
  );
});
